export * from './sidebar.directive';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/directives/sidebar/index.ts